"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
exports.default = react_1.forwardRef(function Button(_a, ref) {
    var _b;
    var children = _a.children, className = _a.className, _c = _a.color, color = _c === void 0 ? 'primary' : _c, _d = _a.variant, variant = _d === void 0 ? 'contained' : _d, _e = _a.disableCapitalization, disableCapitalization = _e === void 0 ? variant !== 'text' : _e, label = _a.label, disabled = _a.disabled, startIcon = _a.startIcon, loading = _a.loading, rest = __rest(_a, ["children", "className", "color", "variant", "disableCapitalization", "label", "disabled", "startIcon", "loading"]);
    if (loading && disabled === undefined) {
        disabled = true;
    }
    if (loading) {
        startIcon = jsx_runtime_1.jsx(core_1.CircularProgress, { size: "1em", color: "inherit" }, void 0);
    }
    var classes = useStyles();
    return (jsx_runtime_1.jsx(Button_1.default, __assign({ className: classnames_1.default(className, (_b = {}, _b[classes.disableCapitalization] = disableCapitalization, _b)), startIcon: startIcon, disabled: disabled, color: color, variant: variant }, rest, { ref: ref }, { children: label || children }), void 0));
});
var useStyles = core_1.makeStyles({
    disableCapitalization: {
        textTransform: 'none',
    },
});
//# sourceMappingURL=Button.js.map